import classNames from 'classnames';
import type { PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';

import { SBHorizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';

import bg from './assets/bg.webp';

const Root = styled(Vertical).attrs({ gap: 0 })`
  position: relative;
  overflow: hidden;
  border: 1.5px solid var(--c-green-400);
  border-radius: var(--double-unit);
  padding: var(--double-unit) var(--double-unit) 0 var(--double-unit);
  background: no-repeat center / cover url(${bg}) padding-box;

  &.disabled {
    border-color: rgba(var(--c-rgb-green-400), 0.25);
    &:hover {
      border-color: rgba(var(--c-rgb-green-400), 0.75);
    }
  }
  transition: 300ms border-color ease-in-out;
`;
const DarkLayer = styled.div`
  position: absolute;
  inset: 0;
  background-color: transparent;
  .disabled & {
    background-color: var(--c-nl-700);
    *:hover > & {
      background-color: var(--c-nl-500);
    }
  }
  transition: 300ms background-color ease-in-out;
`;
const Header = styled(SBHorizontal)`
  width: 100%;
  align-self: stretch;
`;

type Props = {
  disabled?: boolean;
  topLeft?: ReactNode;
  topRight?: ReactNode;
  footer?: ReactNode;
};
export const CategoryTile = ({
  disabled,
  topLeft,
  topRight,
  footer,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <Root className={classNames({ disabled })}>
      <DarkLayer />
      <Header>
        <div>{topLeft}</div>
        <div>{topRight}</div>
      </Header>
      <Vertical center gap={3}>
        {children}
        {footer}
      </Vertical>
    </Root>
  );
};
